// libraries
import React, { useState, useEffect } from "react";
import clsx from "clsx";

export default function Guidelines() {
  // show / hide grid
  const [isGridVisible, setIsGridVisible] = useState(false);
  const [isUmeuTheme, setIsUmeuTheme] = useState<boolean>(() => {
    if (typeof document === "undefined") return false;
    return document.body.classList.contains("umeu");
  });

  const showHideGrid = () => {
    setIsGridVisible((prev) => !prev);
  };

  const toggleUmeuTheme = () => {
    setIsUmeuTheme((prev) => {
      const next = !prev;

      if (next) {
        document.body.classList.add("umeu");
      } else {
        document.body.classList.remove("umeu");
      }

      return next;
    });
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.shiftKey && event.key.toLowerCase() === "g") {
        event.preventDefault();
        showHideGrid();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.classList.remove("umeu");
    };
  }, []);

  return (
    <>
      <button onClick={showHideGrid} className="guidelines-button">
        Grid
      </button>

      <button
        onClick={toggleUmeuTheme}
        className="guidelines-button guidelines-button-colors"
      >
        {isUmeuTheme ? "Colors: UMEU" : "Colors: NEU"}
      </button>

      <div className="breakpoint-indicator"></div>

      <div className={clsx("guidelines-grid", isGridVisible && "visible")}>
        <div className="container">
          <div className="row">
            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>

            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>

            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>

            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>

            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>

            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>

            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>

            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>

            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>

            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>

            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>

            <div className="col-3 col-sm-2 col-md-1">
              <div className="block"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
